
import React, { Component } from 'react';
import './wrong-answers-modal.scss'
import { Modal, ModalBody } from "reactstrap";
import HomeworkApi from '../../../../apis/homework'
import TestApi from '../../../../apis/test'
import { ImageConstants, Constants } from '../../../../constants/constants';
import { getImageSource } from '../../../../utility/image-source'
import CommonUtils from '../../../../utility/common-utilities';
import Latex from "react-latex";
import { InlineMath, BlockMath } from 'react-katex'
import MathJax from "react-mathjax2"
import CwContentViewer from '../../../common/cw-content-viewer/cw-content-viewer'
import CanvasPreview from '../../../common/canvas/canvas'
import GeometryTranspiler from '../../../common/geometry/geometry-parser'
import { element } from 'prop-types';
import ReactTooltip from 'react-tooltip';
import Loading from '../../loading/loading';
// import WronglyAnsweredUsers from './wrongly-answered-users/wrongly-answered-users';


class AddContactComponent extends Component {


    selectedItem = {
    }

    percentageFilters = [{ title: "> 75% Students", value: 100 }, { title: "51-75% Students", value: 75 },
    { title: "25-50% Students", value: 50 }, { title: "< 25% Students", value: 25 }
    ]

    constructor(props) {
        super(props)

        console.log(props)

        if (!this.props.selectedStatus) {
            this.selectedItem = {
                class: this.props.selectedItem.class,
                chapterName: this.props.type === 'TEST' ? this.props.selectedItem.chapters : this.props.selectedItem.chapter,
                createdDate: this.props.selectedItem.createdDateTimestamp,
                _id: this.props.selectedItem._id,
                type: this.props.selectedItem?.type || ''
            }
        } else if (this.props.selectedStatus) {
            this.selectedItem = {
                class: this.props.selectedItem.class,
                chapterName: this.props.selectedItem.chapters ? this.props.selectedItem.chapters : this.props.selectedItem.chapter,
                createdDate: this.props.selectedItem.createdDateTimestamp,
                _id: this.props.selectedItem._id
            }

            console.log(this.selectedItem)
        }
    }

    state = {
        showOptions: true,
        pdfLink: '',
        wrongAnswers: [],
        wrongAnswersOfallUsers: [],
        availabelFiltersHash: {},
        selectedIndex: -1,
        selectedPercentage: 0,
        reload: true
    }

    componentDidMount() {
        if (this.props.selectedStatus) {
            this.getStatusWiseWrongAnswers()
        } else {
            this.getWrongAnswers();
        }
    }

    getWrongAnswers() {
        if (this.props.type == "TEST" || this.selectedItem.type == 'TEST' || this.selectedItem.type === 'CASE_STUDY') {
            this.getTestWrongAnswer()
        } else {
            this.getHomeworkWrongAnswer()
        }
    }

    getHomeworkWrongAnswer(payload = {}) {

        if (this.selectedItem) {
            payload.homeworkId = this.selectedItem._id
            payload.type = this.selectedItem.type
            payload.chapterTitle = this.selectedItem.chapterName
            payload.isPdfGeneration = true
        }

        this.setState({ isLoading: true })

        HomeworkApi.getHomeworkWrongAnswersReport(payload)
            .then(response => {

                // console.log("response", response)
                let wrongAnswersHash = {}
                let result = response.result.sort((x, y) => (x.percentage > y.percentage ? -1 : 1))

                //console.log(result)
                //let filterQuestions = []

                let questionsArray1 = [], users1 = [], questionsArray2 = [], users2 = [],
                    questionsArray3 = [], users3 = [], questionsArray4 = [], users4 = []

                for (let i = 0; i < result.length; i++) {

                    let data = result[i]

                    if (data.percentage < 25) {

                        result[i].filterPercentage = 25
                        result[i].filterRangeText = "Less than 25%"

                        result[i].questionCount = data.questions.length
                        for (let j = 0; j < data.questions.length; j++) {

                            result[i].questions[j].questionPercentage = data.percentage

                        }

                        questionsArray1.push(...result[i].questions)

                        let uniqueAllUsers = ''
                        users1.push(...result[i].users)

                        if (users1.length) {
                            const uniqueIds = [];

                            uniqueAllUsers = users1.filter(element => {
                                if (element) {
                                    const isDuplicate = uniqueIds.includes(element._id);

                                    if (!isDuplicate) {
                                        uniqueIds.push(element._id);

                                        return true;
                                    }
                                    return false;
                                }

                            });
                        }
                        result[i].allQuestionsArray = questionsArray1
                        result[i].allUsers = uniqueAllUsers
                        result[i].questionCount = questionsArray1.length

                    } else if (data.percentage >= 25 && data.percentage <= 50) {

                        result[i].filterPercentage = 50
                        result[i].filterRangeText = "25 - 50%"
                        result[i].questionCount = data.questions.length
                        for (let j = 0; j < data.questions.length; j++) {

                            result[i].questions[j].questionPercentage = data.percentage

                        }

                        questionsArray2.push(...result[i].questions)

                        let uniqueAllUsers = ''
                        users2.push(...result[i].users)

                        if (users2.length) {
                            const uniqueIds = [];

                            uniqueAllUsers = users2.filter(element => {
                                if (element) {
                                    const isDuplicate = uniqueIds.includes(element._id);

                                    if (!isDuplicate) {
                                        uniqueIds.push(element._id);

                                        return true;
                                    }
                                    return false;
                                }
                            });
                        }
                        result[i].allQuestionsArray = questionsArray2
                        result[i].allUsers = uniqueAllUsers
                    } else if (data.percentage > 50 && data.percentage <= 75) {

                        result[i].filterPercentage = 75
                        result[i].filterRangeText = "51 - 75%"
                        result[i].questionCount = data.questions.length
                        for (let j = 0; j < data.questions.length; j++) {

                            result[i].questions[j].questionPercentage = data.percentage

                        }

                        questionsArray3.push(...result[i].questions)

                        let uniqueAllUsers = ''
                        users3.push(...result[i].users)

                        if (users3.length) {
                            const uniqueIds = [];

                            uniqueAllUsers = users3.filter(element => {
                                if (element) {
                                    const isDuplicate = uniqueIds.includes(element._id);

                                    if (!isDuplicate) {
                                        uniqueIds.push(element._id);

                                        return true;
                                    }
                                    return false;
                                }
                            });
                        }
                        result[i].allQuestionsArray = questionsArray3
                        result[i].allUsers = uniqueAllUsers
                    } else if (data.percentage > 75) {

                        result[i].filterPercentage = 100
                        result[i].filterRangeText = "Greater than 75%"
                        result[i].questionCount = data.questions.length
                        for (let j = 0; j < data.questions.length; j++) {

                            result[i].questions[j].questionPercentage = data.percentage

                        }

                        questionsArray4.push(...result[i].questions)

                        let uniqueAllUsers = ''
                        users4.push(...result[i].users)

                        if (users4.length) {
                            const uniqueIds = [];

                            uniqueAllUsers = users4.filter(element => {
                                if (element) {
                                    const isDuplicate = uniqueIds.includes(element._id);

                                    if (!isDuplicate) {
                                        uniqueIds.push(element._id);

                                        return true;
                                    }
                                    return false;
                                }
                            });
                        }
                        result[i].allQuestionsArray = questionsArray4
                        result[i].allUsers = uniqueAllUsers
                    } else {
                        result = []
                    }

                    console.log(result[i])
                    if (!wrongAnswersHash[`${result[i].filterPercentage}`]) {
                        wrongAnswersHash[`${result[i].filterPercentage}`] = [result[i]]
                    }



                }

                const uniqueIds = [];

                const unique = result.filter(element => {
                    const isDuplicate = uniqueIds.includes(element.filterPercentage);

                    if (!isDuplicate) {
                        uniqueIds.push(element.filterPercentage);

                        return true;
                    }
                    return false;
                });


                console.log('wrong hash', wrongAnswersHash)
                console.log('unique', unique)

                //console.log('wrong answer percentage', wrongAnswersHash)

                let filterHash = {}
                Object.keys(wrongAnswersHash).forEach(ele => {
                    filterHash[ele] = ele
                })

                let topQuestions = []

                unique.forEach(item => {
                    topQuestions.push(...item.allQuestionsArray)
                })

                let topFiveWrongAnsweredQuestions = topQuestions.slice(0, 5)

                console.log('top', topFiveWrongAnsweredQuestions)

                this.setState({
                    wrongAnswers: unique, wrongAnswersHash, wrongAnswersOfallUsers: unique,
                    basePath: response.basePath, availabelFiltersHash: filterHash, isLoading: false,
                    pdfLink: response.link
                })

            }).catch(err => {
                console.log(err)
            })
    }


    getTestWrongAnswer(payload = {}) {

        if (this.selectedItem) {
            payload.testId = this.selectedItem._id
        }
        if (this.props.usersId) {
            payload.usersId = this.props.usersId
        }

        payload.chapterTitle = this.props.selectedItem.chapters ? this.getChapterNames(this.selectedItem?.chapterName) : ""
        payload.isPdfGeneration = true

        this.setState({isLoading : true})

        TestApi.getTestWrongAnswersReport(payload)
            .then(response => {

                // console.log("response", response)
                let wrongAnswersHash = {}

                let result = response.result.sort((x, y) => (x.percentage > y.percentage ? -1 : 1))

                console.log(result)


                let filterQuestions = []

                let questionsArray1 = [], users1 = [], questionsArray2 = [], users2 = [],
                    questionsArray3 = [], users3 = [], questionsArray4 = [], users4 = []

                for (let i = 0; i < result.length; i++) {

                    let data = result[i]

                    if (data.percentage < 25) {

                        result[i].filterPercentage = 25
                        result[i].filterRangeText = "Less than 25%"

                        result[i].questionCount = data.questions.length
                        for (let j = 0; j < data.questions.length; j++) {

                            result[i].questions[j].questionPercentage = data.percentage

                        }

                        questionsArray1.push(...result[i].questions)

                        let uniqueAllUsers = ''
                        users1.push(...result[i].users)

                        if (users1.length) {
                            const uniqueIds = [];

                            uniqueAllUsers = users1.filter(element => {
                                const isDuplicate = uniqueIds.includes(element._id);

                                if (!isDuplicate) {
                                    uniqueIds.push(element._id);

                                    return true;
                                }
                                return false;
                            });
                        }
                        result[i].allQuestionsArray = questionsArray1
                        result[i].allUsers = uniqueAllUsers

                    } else if (data.percentage >= 25 && data.percentage <= 50) {

                        result[i].filterPercentage = 50
                        result[i].filterRangeText = "25 - 50%"
                        result[i].questionCount = data.questions.length
                        for (let j = 0; j < data.questions.length; j++) {

                            result[i].questions[j].questionPercentage = data.percentage

                        }

                        questionsArray2.push(...result[i].questions)

                        let uniqueAllUsers = ''
                        users2.push(...result[i].users)

                        if (users2.length) {
                            const uniqueIds = [];

                            uniqueAllUsers = users2.filter(element => {
                                const isDuplicate = uniqueIds.includes(element._id);

                                if (!isDuplicate) {
                                    uniqueIds.push(element._id);

                                    return true;
                                }
                                return false;
                            });
                        }
                        result[i].allQuestionsArray = questionsArray2
                        result[i].allUsers = uniqueAllUsers
                    } else if (data.percentage > 50 && data.percentage <= 75) {

                        result[i].filterPercentage = 75
                        result[i].filterRangeText = "51 - 75%"
                        result[i].questionCount = data.questions.length
                        for (let j = 0; j < data.questions.length; j++) {

                            result[i].questions[j].questionPercentage = data.percentage

                        }

                        questionsArray3.push(...result[i].questions)

                        let uniqueAllUsers = ''
                        users3.push(...result[i].users)

                        if (users3.length) {
                            const uniqueIds = [];

                            uniqueAllUsers = users3.filter(element => {
                                const isDuplicate = uniqueIds.includes(element._id);

                                if (!isDuplicate) {
                                    uniqueIds.push(element._id);

                                    return true;
                                }
                                return false;
                            });
                        }
                        result[i].allQuestionsArray = questionsArray3
                        result[i].allUsers = uniqueAllUsers
                    } else if (data.percentage > 75) {

                        result[i].filterPercentage = 100
                        result[i].filterRangeText = "Greater than 75%"
                        result[i].questionCount = data.questions.length
                        for (let j = 0; j < data.questions.length; j++) {

                            result[i].questions[j].questionPercentage = data.percentage

                        }

                        questionsArray4.push(...result[i].questions)

                        let uniqueAllUsers = ''
                        users4.push(...result[i].users)

                        if (users4.length) {
                            const uniqueIds = [];

                            uniqueAllUsers = users4.filter(element => {
                                const isDuplicate = uniqueIds.includes(element._id);

                                if (!isDuplicate) {
                                    uniqueIds.push(element._id);

                                    return true;
                                }
                                return false;
                            });
                        }
                        result[i].allQuestionsArray = questionsArray4
                        result[i].allUsers = uniqueAllUsers
                    } else {
                        result = []
                    }

                    console.log(result[i])
                    if (!wrongAnswersHash[`${result[i].filterPercentage}`]) {
                        wrongAnswersHash[`${result[i].filterPercentage}`] = [result[i]]
                    }

                }



                const uniqueIds = [];

                const unique = result.filter(element => {
                    const isDuplicate = uniqueIds.includes(element.filterPercentage);

                    if (!isDuplicate) {
                        uniqueIds.push(element.filterPercentage);

                        return true;
                    }
                    return false;
                });






                console.log(wrongAnswersHash)


                //console.log('wrong answer percentage', wrongAnswersHash)

                let filterHash = {}
                Object.keys(wrongAnswersHash).forEach(ele => filterHash[ele] = ele)

                this.setState({
                    wrongAnswers: unique, wrongAnswersHash, wrongAnswersOfallUsers: unique,
                    basePath: response.basePath, availabelFiltersHash: filterHash, isLoading :false, pdfLink : response.link
                })

            }).catch(err => {
            })
    }

    getStatusWiseWrongAnswers = () => {

        if (this.props.type == "TEST") {
            this.getTestWrongAnswer()
        } else {
            this.getHomeworkStatusWiseWrongAnswers()
        }
    }
    getHomeworkStatusWiseWrongAnswers(payload = {}) {
        console.log(this.props.selectedStatus)
        if (this.props.selectedStatus) {
            payload.status = this.props.selectedStatus
            payload.userIds = this.props.userIds
            payload.homeworkId = this.props.homeworkId
        }

        HomeworkApi.getHomeworkStatusWrongAnswersReport(payload)
            .then(response => {

                let wrongAnswersHash = {}
                let result = response.result.sort((x, y) => (x.percentage > y.percentage ? -1 : 1))

                //  console.log(result)
                // let filterQuestions = []

                let questionsArray1 = [], users1 = [], questionsArray2 = [], users2 = [],
                    questionsArray3 = [], users3 = [], questionsArray4 = [], users4 = []

                for (let i = 0; i < result.length; i++) {

                    let data = result[i]

                    if (data.percentage < 25) {

                        result[i].filterPercentage = 25
                        result[i].filterRangeText = "Less than 25%"

                        result[i].questionCount = data.questions.length
                        for (let j = 0; j < data.questions.length; j++) {

                            result[i].questions[j].questionPercentage = data.percentage

                        }

                        questionsArray1.push(...result[i].questions)

                        let uniqueAllUsers = ''
                        users1.push(...result[i].users)

                        if (users1.length) {
                            const uniqueIds = [];

                            uniqueAllUsers = users1.filter(element => {
                                const isDuplicate = uniqueIds.includes(element._id);

                                if (!isDuplicate) {
                                    uniqueIds.push(element._id);

                                    return true;
                                }
                                return false;
                            });
                        }
                        result[i].allQuestionsArray = questionsArray1
                        result[i].allUsers = uniqueAllUsers

                    } else if (data.percentage >= 25 && data.percentage <= 50) {

                        result[i].filterPercentage = 50
                        result[i].filterRangeText = "25 - 50%"
                        result[i].questionCount = data.questions.length
                        for (let j = 0; j < data.questions.length; j++) {

                            result[i].questions[j].questionPercentage = data.percentage

                        }

                        questionsArray2.push(...result[i].questions)

                        let uniqueAllUsers = ''
                        users2.push(...result[i].users)

                        if (users2.length) {
                            const uniqueIds = [];

                            uniqueAllUsers = users2.filter(element => {
                                const isDuplicate = uniqueIds.includes(element._id);

                                if (!isDuplicate) {
                                    uniqueIds.push(element._id);

                                    return true;
                                }
                                return false;
                            });
                        }
                        result[i].allQuestionsArray = questionsArray2
                        result[i].allUsers = uniqueAllUsers
                    } else if (data.percentage > 50 && data.percentage <= 75) {

                        result[i].filterPercentage = 75
                        result[i].filterRangeText = "51 - 75%"
                        result[i].questionCount = data.questions.length
                        for (let j = 0; j < data.questions.length; j++) {

                            result[i].questions[j].questionPercentage = data.percentage

                        }

                        questionsArray3.push(...result[i].questions)

                        let uniqueAllUsers = ''
                        users3.push(...result[i].users)

                        if (users3.length) {
                            const uniqueIds = [];

                            uniqueAllUsers = users3.filter(element => {
                                const isDuplicate = uniqueIds.includes(element._id);

                                if (!isDuplicate) {
                                    uniqueIds.push(element._id);

                                    return true;
                                }
                                return false;
                            });
                        }
                        result[i].allQuestionsArray = questionsArray3
                        result[i].allUsers = uniqueAllUsers
                    } else if (data.percentage > 75) {

                        result[i].filterPercentage = 100
                        result[i].filterRangeText = "Greater than 75%"
                        result[i].questionCount = data.questions.length
                        for (let j = 0; j < data.questions.length; j++) {

                            result[i].questions[j].questionPercentage = data.percentage

                        }

                        questionsArray4.push(...result[i].questions)

                        let uniqueAllUsers = ''
                        users4.push(...result[i].users)

                        if (users4.length) {
                            const uniqueIds = [];

                            uniqueAllUsers = users4.filter(element => {
                                const isDuplicate = uniqueIds.includes(element._id);

                                if (!isDuplicate) {
                                    uniqueIds.push(element._id);

                                    return true;
                                }
                                return false;
                            });
                        }
                        result[i].allQuestionsArray = questionsArray4
                        result[i].allUsers = uniqueAllUsers
                    } else {
                        result = []
                    }

                    console.log(result[i])
                    if (!wrongAnswersHash[`${result[i].filterPercentage}`]) {
                        wrongAnswersHash[`${result[i].filterPercentage}`] = [result[i]]
                    }

                }



                const uniqueIds = [];

                const unique = result.filter(element => {
                    const isDuplicate = uniqueIds.includes(element.filterPercentage);

                    if (!isDuplicate) {
                        uniqueIds.push(element.filterPercentage);

                        return true;
                    }
                    return false;
                });






                console.log(wrongAnswersHash)


                //console.log('wrong answer percentage', wrongAnswersHash)

                let filterHash = {}
                Object.keys(wrongAnswersHash).forEach(ele => filterHash[ele] = ele)

                this.setState({
                    wrongAnswers: unique, wrongAnswersHash, wrongAnswersOfallUsers: unique,
                    basePath: response.basePath, availabelFiltersHash: filterHash
                })

            }).catch(err => {
            })
    }


    createElementFromHTML = (html) => {
        var template = document.createElement('template');
        html = html.trim(); // Never return a text node of whitespace as the result
        template.innerHTML = html;
        return template.content.firstChild;
    }

    getCanvasSize(coordinates = []) {
        if (!coordinates) return {}
        let maxHeight = 0, maxWidth = 0
        for (let i = 0; i < coordinates.length; i++) {
            for (let j = 0; j < coordinates[i].points.length; j++) {
                if (maxWidth < coordinates[i].points[j].x) {
                    maxWidth = coordinates[i].points[j].x
                }
                if (maxHeight < coordinates[i].points[j].y) {
                    maxHeight = coordinates[i].points[j].y
                }
            }
        }
        return { maxHeight, maxWidth }
    }

    getBlankOptionValueDropDown(content) {

        let styles = {
            p: { fontSize: '23px', fontFamily: "Mont", fontStyle: 'normal', fontWeight: "500" }
        }

        if (content && content.items && content.items.length) {
            let correctItem = content.items.filter((item) => item.isCorrect);
            let correctAnswer = correctItem[0].content.replace(/(<p>(\s|&nbsp;)*<\/p>)*$/, "");
            if (correctItem[0].content) {
                return <CwContentViewer content={correctAnswer} />
            } else {
                return <></>
            }
        }
        return <></>
    }

    getJsxForBlankTypeDropDown(option, index) {

        console.log(option, index, this.state.selectedDropDownIndex, this.props.isReadOnly)

        console.log(this.state.actionSheet)

        let styles = {
            p: { fontSize: '19px', fontFamily: "Mont", fontStyle: 'normal', fontWeight: "500" }
        }

        return (
            <div className="position-relative" style={{}}>

                {this.state.selectedDropDownIndex === index ?
                    <>
                        <div className="row mb-2 mt-2 mr-0 ml-0" style={{}}>

                            <div className="blank-wrapper padding-for-dropdown">
                                <div className="dropdown-input">
                                    <div className="d-inline-block alphabet-option ml-2 mr-2">
                                        <div className="circle">{CommonUtils.getAlphabet(index).toUpperCase()}</div>
                                    </div>
                                    {/* <img className="option-separator-2" src={getThemeImageSource(ImageConstants.OPTION_SEPARATOR, this.props.categoryThemeId)} /> */}
                                    <div className="d-inline-block ml-2" style={{}}>
                                        {
                                            option.selectedText ?
                                                this.parser.parseWithStyles(`${option.selectedText.replace(/(<p>(\s|&nbsp;)*<\/p>)*$/, "")}`, { p: styles.p, "cw-math": styles.p })
                                                : <span className="cw-input-for-dropdown" style={{}}>
                                                    {"Select One"}</span>
                                        }
                                    </div>

                                    <div className="float-right mt-2" style={{}}>
                                        <img className="dropdown-arrow-size" src={getImageSource(ImageConstants.DROPDOWN_ARROW_BLACK)} />
                                    </div>
                                </div>

                            </div>


                            {/* </LinearGradient> */}
                        </div>
                        {/* {this.state.actionSheet && <ActionSheet modal={this.state.actionSheet} toggleActionSheet={this.toggleActionSheet} options={this.state.dropDownData} onSelect={this.onSelect} categoryThemeId={this.props.categoryThemeId}></ActionSheet>} */}

                    </>


                    :
                    // <LinearGradient colors={Colors.appTheme.gradient1} start={{ x: 0, y: 0 }} end={{ x: 0, y: 1.2 }} style={styles.linearGradiendCard}>
                    <div className="row  mb-2 mt-2 mr-0 ml-0 cursor-pointer" style={{}}>

                        <div className="blank-wrapper padding-for-dropdown">
                            <div className="dropdown-input">
                                <div className="d-inline-block alphabet-option ml-2 mr-2">
                                    <div className="circle">{CommonUtils.getAlphabet(index).toUpperCase()}</div>
                                </div>
                                <img className="option-separator-2" src={getImageSource(ImageConstants.OPTION_SEPARATOR)} />
                                {
                                    // !this.props.isReadOnly ?
                                    //     <div className="d-inline-block ml-2" style={{}}>
                                    //         {
                                    //             option.selectedText ?
                                    //                 this.parser.parseWithStyles(`${option.selectedText.replace(/(<p>(\s|&nbsp;)*<\/p>)*$/, "")}`, { p: styles.p, "cw-math": styles.p })
                                    //                 : <span className="cw-input-for-dropdown" style={{}}>
                                    //                     {"Select One"}</span>
                                    //         }
                                    //     </div>
                                    //     :
                                    <div className="d-inline-block ml-2" style={{}}>
                                        {this.getBlankOptionValueDropDown(option)}
                                    </div>
                                }

                                <div className="float-right mt-2" style={{}}>
                                    {/* <img className="dropdown-arrow-size" src={getImageSource(ImageConstants.ARROW_DOWN_ANGLE)} /> */}
                                </div>
                            </div>

                        </div>


                        {/* </LinearGradient> */}
                    </div>
                }

            </div>

        )
    }

    getBlankOptionValue = (content) => {

        let styles = {
            p: { fontSize: '20px', fontFamily: "Mont", fontStyle: 'normal', fontWeight: "500" }
        }

        if (content && content.items && content.items.length) {
            // let parsedJsx = this.parser.parseWithStyles(`${content.items[0].content.replace(/(<p>(\s|&nbsp;)*<\/p>)*$/, "")}`, { p: styles.p, "cw-math": styles.p })
            return (
                <div className="d-inline-block ml-2">
                    <CwContentViewer content={content.items[0].content.replace(/(<p>(\s|&nbsp;)*<\/p>)*$/, "")} />
                </div>
            )
        }
        return <></>
    }

    getJsxForBlank(option, index) {
        return (
            <div className="">

                <div >
                    {/* <LinearGradient colors={Colors.appTheme.gradient1} start={{ x: 0, y: 0 }} end={{ x: 0, y: 1.2 }} style={styles.blank}> */}

                    <div className="row  mb-2 mt-2 mr-0 ml-0">
                        <div className="blank-wrapper d-flex align-items-center ">
                            <div className="blank-option">
                                <div className="d-inline-block alphabet-option ml-2 mr-2">
                                    <div className="circle">{CommonUtils.getAlphabet(index).toUpperCase()}</div>
                                </div>

                                <img className="option-separator" src={getImageSource(ImageConstants.OPTION_SEPARATOR)} />

                                {
                                    this.getBlankOptionValue(option)

                                }

                            </div>

                            {/* <TouchableOpacity onPress={() => this.textInput[index].focus()} style={styles.keyboard} >
                                <Image source={getThemeImageSource(ImageConstants.ASSESSMENT_KEYBOARD, this.props.categoryThemeId)} />
                            </TouchableOpacity> */}
                        </div>
                        {/* </LinearGradient> */}
                    </div>
                </div>
            </div >


        )
    }

    getContentUsingContentType(option, style) {

        let content = option.content.replace(/^(<p>(\s|&nbsp;)*<\/p>)*/, "");

        content = content.replace(/(<p>(\s|&nbsp;)*<\/p>)*$/, "");

        if (option.contentType == 1) {
            return <CwContentViewer content={content} />
        } else if (option.contentType == 2) {
            return <div className=''>
                <img className='image-option-container' src={option.content} alt="" />
            </div>
        }

    }

    renderReadOnlyItem = (option) => {
        let options = option.items;
        return (
            options.map((option, i) => (
                <div className="group-items d-flex align-items-center justify-content-center position-relative">

                    {option.contentType == 1 ?
                        <div className="">
                            <div className="text-center">{this.getContentUsingContentType(option, 'answer')}</div>
                        </div>
                        :
                        <div className="">
                            <div className="text-center">{this.getContentUsingContentType(option, 'answer')}</div>
                        </div>

                    }
                </div>
            ))
        )
    }

    // renderContentType = (contentType, content) => {

    //     switch (contentType) {

    //         case 1:
    //             return (
    //                 <div>
    //                     <div >
    //                         {content.content.options.map((item, index) =>
    //                             <div className='mb-2 ml-2 row sequence-option'>
    //                                 <div className='col-1'>
    //                                     <div className='radio-btn'></div>
    //                                 </div>
    //                                 <div className='col-10 content-alignment'>{item.contentTypeName == 'TEXT' ?
    //                                     // <span className='' dangerouslySetInnerHTML={{ __html: item.content }} />
    //                                     <CwContentViewer content={item.content} />
    //                                     :
    //                                     <div className=''>
    //                                         <img className='image-option-container' src={item.content} alt="" />
    //                                     </div>
    //                                 }
    //                                 </div>

    //                             </div>
    //                         )}

    //                     </div>
    //                 </div>

    //             )

    //         case 2:
    //             return (
    //                 <div>
    //                     <div >
    //                         {content.content.options.map((item, index) =>
    //                             <div className='mb-2 ml-2 row sequence-option'>
    //                                 <div className='col-1'>
    //                                     <div className='check-box'></div>
    //                                 </div>
    //                                 <div className='col-10 content-alignment'>{item.contentTypeName == 'TEXT' ?
    //                                     <CwContentViewer content={item.content} />
    //                                     :
    //                                     <div className=''>
    //                                         <img className='image-option-container' src={item.content} alt="" />
    //                                     </div>
    //                                 }
    //                                 </div>

    //                             </div>
    //                         )}

    //                     </div>
    //                 </div>

    //             )

    //         case 4:
    //             return (

    //                 <div>
    //                     <div className='row'>
    //                         {content.content.options.map((item, index) =>
    //                             <div className='col-2 matching-option'>
    //                                 {item.question.contentTypeName == 'TEXT' ?
    //                                     // <div className='match-option' dangerouslySetInnerHTML={{ __html: item.answer.content }} />
    //                                     <div className='match-option'><CwContentViewer content={item.question.content} /></div>
    //                                     :
    //                                     <div className='match-option'>
    //                                         <img className='image-option-container' src={item.question.content} alt="" />
    //                                     </div>
    //                                 }
    //                                 <div className='text-center'><img className='match-arrow my-2' onClick={this.props.onClose} src={getImageSource(ImageConstants.MATCHING_ARROW)} /></div>
    //                                 {item.answer.contentTypeName == 'TEXT' ?
    //                                     // <div className='match-option' dangerouslySetInnerHTML={{ __html: item.answer.content }} />
    //                                     <div className='match-option'><CwContentViewer content={item.answer.content} /></div>
    //                                     :
    //                                     <div className='match-option'>
    //                                         <img className='image-option-container' src={item.answer.content} alt="" />
    //                                     </div>
    //                                 }
    //                             </div>
    //                         )}

    //                     </div>
    //                 </div>

    //             )

    //         case 5:

    //             return (
    //                 <div>
    //                     <div >
    //                         {content.content.options.map((item, index) =>
    //                             <div className='mb-2 ml-2 row sequence-option'>
    //                                 <div className='col-2'>
    //                                     <img className='match-arrow drag-container' onClick={this.props.onClose} src={getImageSource(ImageConstants.DRAG_ICON)} />
    //                                 </div>
    //                                 <div className='sequence-border'></div>
    //                                 <div className='col 6 '>{item.contentTypeName == 'TEXT' ?
    //                                     // <span className='' dangerouslySetInnerHTML={{ __html: item.content }} />
    //                                     <CwContentViewer content={item.content} />
    //                                     :
    //                                     <div className=''>
    //                                         <img className='image-option-container' src={item.content} alt="" />
    //                                     </div>
    //                                 }
    //                                 </div>

    //                             </div>
    //                         )}

    //                     </div>
    //                 </div>

    //             )

    //         case 6:

    //             let items = []

    //             for (let i = 0; i < content.content.options.length; i++) {
    //                 items = items.concat(content.content.options[i].items)
    //             }
    //             return (
    //                 <div>
    //                     <div className='row option-wrapper '>
    //                         {items.map((item, index) =>
    //                             <div className='ml-2 mt-2'> {item.contentTypeName == 'TEXT' ?
    //                                 // <div className='group-items' dangerouslySetInnerHTML={{ __html: item.content }} />
    //                                 <div className='group-items'><CwContentViewer content={item.content} /></div>
    //                                 :
    //                                 <div className='group-items'>
    //                                     <img className='image-option-container' src={item.content} alt="" />
    //                                 </div>
    //                             }</div>
    //                         )}
    //                     </div>
    //                     <div className='row mt-4'>
    //                         {content.content.options.map((item, index) =>
    //                             <div className='ml-2 group-option'>
    //                                 <div className='group-header px-3'>
    //                                     {/* <div className='text-center mt-2' dangerouslySetInnerHTML={{ __html: item.title }} /> */}
    //                                     <div className='text-center mt-2'><CwContentViewer content={item.title} /></div>
    //                                 </div>

    //                             </div>
    //                         )}

    //                     </div>
    //                 </div>
    //             )

    //         case 10:
    //             if (content && content.content && content.content.canvas && content.content.canvas.render && content.content.canvas.render.script && content.content.canvas.render.script) {
    //                 let payload = GeometryTranspiler.transpile(content.content.canvas.render.script, 37.7952755906, 5) //centimeter ratio and x offset
    //                 if (payload) {
    //                     let { maxWidth, maxHeight } = this.getCanvasSize(payload)
    //                     this.canvasMaxWidth = maxWidth + 100
    //                     this.canvasMaxHeight = maxHeight + 100
    //                 }

    //                 return (
    //                     <CanvasPreview id={Math.random()} coordinates={payload || []} maxWidth={this.canvasMaxWidth} maxHeight={this.canvasMaxHeight} />
    //                 )
    //             }

    //         default:
    //             return ("")
    //     }

    // }

    getContentTypeOptionsForMultiStep(content, questionNo) {
        console.log(content)

        let isMultiStep = content.content.isMultiStep ? content.content.isMultiStep : false

        console.log(content.content)

        if (isMultiStep) {
            return content.content.steps.map((content, index) => (
                <>
                    <div className='row mt-4 mb-4 align-items-center'>
                        <div className='col-1 part-title'>
                            {questionNo + 1} {CommonUtils.getAlphabet(index)}
                        </div>
                        <div className='col part-question'>
                            <CwContentViewer content={content.content.title} />
                        </div>
                    </div>
                    {content.content.images && content.content.images.length ? content.content.images.map((image, imageIndex) =>
                        <img className='image-container mb-4 mr-3' src={image.imageUrl} alt="" />
                    )
                        :
                        ""}
                    {this.renderContentType(content.content.type, content)}
                </>
            ))
        }
    }

    renderContentType = (contentType, content) => {

        switch (contentType) {

            case 1:
                return (
                    <div>
                        <div className='margin-for-options'>
                            {content.content.options.map((item, index) =>
                                <div className='mb-2 ml-2 row sequence-option'>
                                    <div className='col-1 '>
                                        <div className='radio-btn'><div className={`${item.isCorrect === true ? 'inner-selected' : ''}`}></div></div>
                                    </div>
                                    <div className='col align-self-center'>
                                        {item.contentTypeName == 'TEXT' ?
                                            // <span className='' dangerouslySetInnerHTML={{ __html: item.content }} />
                                            <CwContentViewer content={item.content} />
                                            :
                                            <div className=''>
                                                <img className='image-option-container' src={item.content} alt="" />
                                            </div>
                                        }
                                    </div>

                                </div>
                            )}

                        </div>
                    </div>

                )

            case 2:
                return (
                    <div>
                        <div className='margin-for-options'>
                            {content.content.options.map((item, index) =>
                                <div className='mb-2 ml-2 row sequence-option'>
                                    <div className='col-2 '>
                                        <div className='check-box'> {item.isCorrect === true ? <img className="tick-mark-size" src={getImageSource(ImageConstants.TICK_MARK_ICON)} /> : <></>}</div>
                                    </div>
                                    <div className='col'>{item.contentTypeName == 'TEXT' ?
                                        <CwContentViewer content={item.content} />
                                        :
                                        <div className=''>
                                            <img className='image-option-container' src={item.content} alt="" />
                                        </div>
                                    }
                                    </div>

                                </div>
                            )}

                        </div>
                    </div>

                )

            case 3:

                return (
                    <div>
                        <div className='margin-for-options'>
                            {
                                content.content.options && content.content.options.length && content.content.options.map((option, index) => (
                                    <React.Fragment key={'fillInTheBlank' + index}>
                                        {option.contentType == 3 ?
                                            this.getJsxForBlank(option, index)
                                            : this.getJsxForBlankTypeDropDown(option, index)
                                        }
                                    </React.Fragment>
                                ))
                            }
                        </div>
                    </div>
                )

            case 4:
                return (

                    <div className='margin-for-options'>
                        <div className='row m-0 p-0'>
                            {content.content.options.map((item, index) =>
                                <div className='col-4 matching-option'>
                                    {item.question.contentTypeName == 'TEXT' ?
                                        // <div className='match-option' dangerouslySetInnerHTML={{ __html: item.answer.content }} />
                                        <div className='match-option'><CwContentViewer content={item.question.content} /></div>
                                        :
                                        <div className='match-option'>
                                            <img className='image-option-container' src={item.question.content} alt="" />
                                        </div>
                                    }
                                    <div className='text-center'><img className='match-arrow my-2' onClick={this.props.onClose} src={getImageSource(ImageConstants.MATCHING_ARROW)} /></div>
                                    {item.answer.contentTypeName == 'TEXT' ?
                                        // <div className='match-option' dangerouslySetInnerHTML={{ __html: item.answer.content }} />
                                        <div className='match-option'><CwContentViewer content={item.answer.content} /></div>
                                        :
                                        <div className='match-option'>
                                            <img className='image-option-container' src={item.answer.content} alt="" />
                                        </div>
                                    }
                                </div>
                            )}

                        </div>
                    </div>

                )

            case 5:

                return (
                    <div>
                        <div className='margin-for-options'>
                            {content.content.options.map((item, index) =>
                                <div className='mb-2 ml-2 row sequence-option'>
                                    <div className='col-2'>
                                        <img className='match-arrow drag-container' onClick={this.props.onClose} src={getImageSource(ImageConstants.DRAG_ICON)} />
                                    </div>
                                    <div className='sequence-border'></div>
                                    <div className='col '>{item.contentTypeName == 'TEXT' ?
                                        // <span className='' dangerouslySetInnerHTML={{ __html: item.content }} />
                                        <CwContentViewer content={item.content} />
                                        :
                                        <div className=''>
                                            <img className='image-option-container' src={item.content} alt="" />
                                        </div>
                                    }
                                    </div>

                                </div>
                            )}

                        </div>
                    </div>

                )

            case 6:

                let items = []

                for (let i = 0; i < content.content.options.length; i++) {
                    items = items.concat(content.content.options[i].items)
                }
                return (
                    <div className='margin-for-options'>
                        {/* <div className='row option-wrapper '>
                            {items.map((item, index) =>
                                <div className='ml-2 mt-2'> {item.contentTypeName == 'TEXT' ?
                                    // <div className='group-items' dangerouslySetInnerHTML={{ __html: item.content }} />
                                    <div className='group-items'><CwContentViewer content={item.content} /></div>
                                    :
                                    <div className='group-items'>
                                        <img className='image-option-container' src={item.content} alt="" />
                                    </div>
                                }</div>
                            )}
                        </div> */}
                        <div className="matching-question-container d-flex flex-row mt-4">
                            {content.content.options.map((option, index) => (
                                <div key={"dropZone" + index} className="drop-zone">
                                    <div className="text-center p-1 drop-zone-title">
                                        <CwContentViewer content={option.title} />
                                    </div>
                                    <div className="d-flex flex-row answer-wrapper justify-content-center">
                                        {
                                            this.renderReadOnlyItem(option)
                                        }
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                )

            case 10:
                if (content && content.content && content.content.canvas && content.content.canvas.render && content.content.canvas.render.script && content.content.canvas.render.script) {
                    let payload = GeometryTranspiler.transpile(content.content.canvas.render.script, 37.7952755906, 5) //centimeter ratio and x offset
                    if (payload) {
                        let { maxWidth, maxHeight } = this.getCanvasSize(payload)
                        this.canvasMaxWidth = maxWidth + 100
                        this.canvasMaxHeight = maxHeight + 100
                    }

                    return (
                        <CanvasPreview id={Math.random()} coordinates={payload || []} maxWidth={this.canvasMaxWidth} maxHeight={this.canvasMaxHeight} />
                    )
                }

            default:
                return (<div className='text-center'><b>COMING SOON</b></div>)
        }

    }

    onClickPercentage = (item, index) => {

        // console.log(item)
        // console.log(index)
        // console.log(this.state.selectedIndex)

        if (index == this.state.selectedIndex) {
            this.setState({ selectedPercentage: '', wrongAnswers: this.state.wrongAnswersOfallUsers, selectedIndex: -1, showStudents: false })
        } else {
            this.setState({
                selectedPercentage: item.value, selectedIndex: index, reload: false,
                wrongAnswers: (this.state.wrongAnswersHash[item.value] ? this.state.wrongAnswersHash[item.value] : []), showStudents: false
            }, () => {
                this.setState({ reload: true })
            })
        }
    }

    viewStudents = (item, index) => {
        console.log(index)
        this.setState({ showStudents: true, students: item.allUsers, viewStudentIndex: index })
        // alert('test')
    }

    closeStudents = () => {
        this.setState({ showStudents: false, students: [] })
    }

    onClickBack = () => {
        this.props.delegate && this.props.delegate.hideReport && this.props.delegate.hideReport()
    }

    getChapterNames(chapters) {
        let arr = []
        for (let i = 0; i < chapters.length; i++) {
            arr.push(chapters[i].title)
        }
        return arr.join(", ")
    }



    renderBreadcrumb = () => {

        if (!this.props.selectedStatus) {
            return (
                <div className='breadcrumb-1 ml-3 '>
                    <span>{`${this.selectedItem.class || ""} >`}</span>
                    <span className='pl-2'>{`${this.props.selectedItem?.section || ""} >`}</span>
                    <span className='pl-2'>{this.props.type === 'TEST' ? this.getChapterNames(this.selectedItem?.chapterName) : this.props.selectedItem.chapter} {`>`}</span>
                    <span className='pl-2'>{this.getDate(this.selectedItem.createdDate)}</span>
                </div>
            )
        } else {
            return (
                <div className='breadcrumb-1 ml-3 '>
                    <span>{`${this.selectedItem.class || ""} >`}</span>
                    <span className='pl-2'>{`${this.props.selectedItem?.section || ""} >`}</span>
                    <span className='pl-2'>{this.props.selectedItem.chapters ? this.getChapterNames(this.selectedItem?.chapterName) : this.props.selectedItem.chapter} {`>`}</span>
                    <span className='pl-2'>{this.getDate(this.selectedItem.createdDate)}</span>
                </div>
            )
        }



    }

    getDate = (timeStamp, getYear) => {

        let dateFormat = new Date(timeStamp).toDateString();

        let date = dateFormat.split(" ")[2];

        let month = dateFormat.split(" ")[1];

        let year = dateFormat.split(" ")[3];

        if (getYear) {
            return date + " " + month + " " + year;
        } else {
            return date + " " + month;
        }
    }

    showAnswers(index) {

        if (this.state.selectedQuestionIndex === index) {
            this.setState({ showCorrectAnswer: false, selectedQuestionIndex: -1 })
        } else {
            this.setState({ showCorrectAnswer: true, selectedQuestionIndex: index })
        }

    }



    renderLearningResourceListCard() {
        return (
            <div className="learning-resource-download-list mt-1">
                <img className="close-icon cursor-pointer float-right" onClick={() => this.hideDownloadList()} src={getImageSource(ImageConstants.CROSS)} />
                <div className="mt-4 mb-4">
                    <div className="d-flex justify-content-start ml-2" >
                        <div>
                            <a className="anchor-tag" download
                                href={this.state.pdfLink} >
                                <img className="download-icon cursor-pointer mr-2" src={getImageSource(ImageConstants.BLACK_DOWNLOAD_ICON)}></img>
                                <span className="download-item">Download</span>
                            </a>
                        </div>
                    </div>
                    {/* <img className="divider-width" src={getImageSource(ImageConstants.LIST_DIVIER)} /> */}

                    {/* <div className="d-flex justify-content-start ml-2">
                            <div>
                                <a className="anchor-tag" href={this.state.cheatSheetPdf} download target='_blank' >
                                    <img className="download-icon cursor-pointer mr-2" src={getImageSource(ImageConstants.BLACK_DOWNLOAD_ICON)}></img>
                                    <span className="download-item">Cheat Sheet</span>
                                </a>
                            </div>
                        </div> */}

                </div>
            </div>
        )
    }

    showDownloadList() {
        this.setState({ showDownloadReportList: true })
    }

    hideDownloadList() {
        this.setState({ showDownloadReportList: false })
    }



    render() {
        return (
            <>



                <div className="wrong-answers-modal">


                    {/* <div className='item-1' >
                        <img className='back-icon cursor-pointer' src={getImageSource(ImageConstants.BACK_ICON)} onClick={() => this.onClickBack()} />
                    </div>


                    <div className='container-1'>
                        <div className='item-2'>
                            <span className='screen-title title-center my-5'>Most Wrongly Answered</span>
                        </div>
                    </div>
                    <span>{this.renderBreadcrumb()}</span> */}
                    <div className='item-1 mb-3' >
                        <img className='back-icon cursor-pointer' src={getImageSource(ImageConstants.BACK_ICON)} onClick={() => this.onClickBack()} />
                    </div>

                    <div className='d-flex align-items-center justify-content-between header-report-card mb-3'>
                        <div className='d-flex align-items-center'>
                            <div>
                                <img className='circle-image' src={getImageSource(ImageConstants.WRONG_QUESTIONS_DETAIL_REPORT)} />
                            </div>
                            <div className='ml-2'>
                                <div className=''>
                                    <span className='screen-title-1 title-center'>Most Wrongly Answered</span>
                                    <span>{this.renderBreadcrumb()}</span>
                                </div>
                            </div>
                        </div>
                        {
                            this.state.pdfLink ?
                                <div className='position-relative' onMouseEnter={ReactTooltip.rebuild}>
                                    <img className='green-download-icon pt-3 cursor-pointer'
                                        data-tip="Download Report" onClick={() => this.showDownloadList()}
                                        src={getImageSource(ImageConstants.GREEN_DOWNLOAD_ICON)} />
                                    {
                                        this.state.showDownloadReportList ?
                                            this.renderLearningResourceListCard()
                                            :
                                            <></>
                                    }

                                </div>
                                : <></>
                        }
                    </div>


                    <div className='qs-background-color'>
                        <div className='ml-5 mt-4 row'>
                            {this.state.wrongAnswersOfallUsers && this.state.wrongAnswersOfallUsers.length >= 1 ? this.percentageFilters.map((item, index) =>
                                <div className={this.state.selectedIndex == index ? 'selected-percentage-container cursor-pointer' : 'percentage-container cursor-pointer'} onClick={() => this.onClickPercentage(item, index)}>
                                    <div className={this.state.selectedIndex == index ? 'selected-percentage-text' : 'percentage-text'}>{item.title}</div>
                                </div>
                            )
                                :
                                <></>}
                        </div>



                        {
                            this.state.reload ?
                                <div className="wrong-answers-modal-max-height">
                                    {this.state.wrongAnswers?.length ? this.state.wrongAnswers.map((item, index) =>
                                        <div className='m-5' >
                                            {/* <div className='text-right mb-1 mt-6'><span className='count-text'><b>{item.users.length}</b> Students got following Questions wrong</span></div> */}



                                            {item.filterPercentage ?
                                                <div className='mb-2 mt-6 ml-3' style={{ position: "relative" }}>
                                                    {/* <span className='count-text'>{item.filterRangeText} of Students got following {item.allQuestionsArray?.length} Questions wrong</span>  */}
                                                    <div className='text-right'>
                                                        <span className='view-students mr-1 cursor-pointer' onClick={() => this.viewStudents(item, index)}>View Students</span>
                                                    </div>

                                                    {this.state.showStudents && this.state.viewStudentIndex == index ?
                                                        <div className={`students-card-new `}>
                                                            {/* ${ this.props.selectedStatus  ? 'positionstudentcard1':''} ${this.selectedItem.type == "TEST" ? "positionstudentcard": ''} */}
                                                            <div className="row">
                                                                <div className="col student-item-1">
                                                                    <img className="close-icon cursor-pointer mr-2" onClick={this.closeStudents} src={getImageSource(ImageConstants.CROSS)} />
                                                                </div>
                                                            </div>

                                                            <div className='student-card-new-wrapper'>
                                                                {
                                                                    this.state.students && this.state.students.length ? this.state.students.map((item, index) =>

                                                                        <div className='px-4 row align-items-center mb-2'>
                                                                            {/* <div className="profile-avatar text-center mr-2 d-inline-block">
                                                                                <div className="row justify-content-center">
                                                                                    {item.image ? <img className="" alt="img" src={`${this.state.basePath}${item.image}`} />
                                                                                        :
                                                                                        <img className="" alt="img" src={Constants.ALTERNATE_STUDENT_IMAGE} />}
                                                                                </div>
                                                                            </div> */}
                                                                            <div className='student-name ml-2'>
                                                                                {item.name}
                                                                            </div>
                                                                        </div>

                                                                    )
                                                                        :
                                                                        ""
                                                                }
                                                            </div>


                                                        </div>

                                                        :
                                                        ""
                                                    }
                                                </div>
                                                : ""}



                                            <div className='question-container ml-3' style={{ background: "#F8F8F8" }}>
                                                {item.allQuestionsArray?.map((question, qnIndex) =>
                                                    // this.createElementFromHTML(question.content.title)
                                                    <div className='row p-4 cursor-pointer' onMouseEnter={ReactTooltip.rebuild} onClick={() => this.showAnswers(qnIndex)}>
                                                        <div className='col-2 qs-font-weight'>{`${qnIndex + 1} - `}<span className='qs-subtext-size'>{`${question?.questionPercentage}`}%  Students</span></div>
                                                        <div className='col-9 qs-line-height' >
                                                            <CwContentViewer content={question.content.title} />
                                                            {question.content.images && question.content.images.length ? question.content.images.map((image, imageIndex) =>
                                                                <img className='image-container mb-4 mr-3' src={image.imageUrl} alt="" />
                                                            )
                                                                :
                                                                ""}
                                                            {
                                                                this.state.selectedQuestionIndex === qnIndex && this.state.showCorrectAnswer ?
                                                                    <div className='mt-4 option-list'>
                                                                        {/* <div className='divider-line'></div> */}
                                                                        {question.content.isMultiStep ? this.getContentTypeOptionsForMultiStep(question, qnIndex) : this.renderContentType(question.content.type, question)}
                                                                    </div>

                                                                    : <></>

                                                            }

                                                            {/* {this.state.showOptions && this.renderContentType(question.content.type, question)} */}
                                                        </div>

                                                        <div className='col'>
                                                            {/* {
                                                                this.props.type == "TEST" || this.selectedItem.type == 'TEST' ? <></> : <img className='info-icon-size'
                                                                    data-tip={`${question.eloTitle}`}
                                                                    src={getImageSource(ImageConstants.INFO1)} />
                                                            } */}

                                                            {
                                                             <img className='info-icon-size'
                                                                    data-tip={`${question.eloTitle ? question.eloTitle : ''}`}
                                                                    src={getImageSource(ImageConstants.INFO1)} />
                                                            }

                                                            <img className='arrow-size ml-2 cursor-pointer' src={this.state.selectedQuestionIndex === qnIndex && this.state.showCorrectAnswer ? getImageSource(ImageConstants.ARROW_UP_ANGLE) : getImageSource(ImageConstants.ARROW_DOWN_ANGLE)} ></img>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        </div>

                                    )
                                        :
                                        this.state.isLoading ? <Loading />
                                            :
                                            !this.state.wrongAnswers?.length ?
                                                <div className='mt-3'>
                                                    <div className='text-center'>No records Found</div>
                                                </div>
                                                :
                                                <></>
                                    }
                                </div>
                                : ''
                        }

                    </div>
                </div>
                <ReactTooltip className="border arrow" arrowColor="#C4C4C4" ref={el => this.tooltip = el}
                    multiline={true}
                    place='left'
                    type='light' effect='solid'
                    event="mouseover mouseenter"
                    eventOff="mouseleave mouseout scroll mousewheel blur" />
            </>
        );
    }
}

export default AddContactComponent;